"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormInput = void 0;
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const form_input_base_1 = require("./form-input-base");
const form_input_html_1 = __importDefault(require("./form-input.html"));
let ItpFormInput = class ItpFormInput extends (0, vue_property_decorator_1.Mixins)(form_input_base_1.FormInputBase) {
    plaintext;
    type;
    number;
    dumpValue(value) {
        if (this.type === 'number') {
            if (_.isString(value) && value.trim() === '') {
                return null;
            }
            if (value === null) {
                return null;
            }
            if (_.isString(value)) {
                return _.toNumber(value.replace(/\s/g, "").replace(/,/g, '.'));
            }
        }
        return value;
    }
};
exports.ItpFormInput = ItpFormInput;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Boolean)
], ItpFormInput.prototype, "plaintext", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'text' }),
    __metadata("design:type", String)
], ItpFormInput.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Boolean)
], ItpFormInput.prototype, "number", void 0);
exports.ItpFormInput = ItpFormInput = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_input_html_1.default,
        inject: {
            componentContext: 'componentContext',
            formContext: { default: null }
        }
    })
], ItpFormInput);
//# sourceMappingURL=form-input.js.map